import React from 'react';

const WhatsAppButton = ({ phoneNumber = '916383836429', message = "Hello! I'm interested in learning Silambam" }) => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label="Contact us on WhatsApp"
        >
            💬
        </a>
    );
};

export default WhatsAppButton;
